import * as bi from 'react-bootstrap-icons';
import { Flex, Page } from 'components';
import { Navbar, Tabs } from './components';
import { RoutingUrls } from 'common/const';
import './style.scss';

interface IProps {
  title: string;
  frameTitle: string;
  children?: React.ReactNode;
}

function PageSidebar(props: IProps) {
  return (
    <Page title={props.title}>
      <Flex
        direction='column'
        gap={20}
      >
        <Navbar title={props.frameTitle} />

        <div className='tabbed-content-JyaE'>
          <div className='all-space-filler-3xum'></div>
          <div className='content-uETiB'>{props.children}</div>
          <div className='sidebar-filler-Kpt7'></div>
        </div>
      </Flex>

      <Tabs
        tabs={[
          {
            icon: <bi.House />,
            title: 'Главная',
            href: RoutingUrls.Main,
          },
          {
            icon: <bi.Luggage />,
            title: 'Купить билет',
            href: RoutingUrls.Trips,
          },
          {
            icon: <bi.TicketPerforated />,
            title: 'Мои билеты',
            href: RoutingUrls.Tickets,
          },
          {
            icon: <bi.Gear />,
            title: 'Параметры',
            href: RoutingUrls.Settings,
          },
        ]}
      />
    </Page>
  );
}

export default PageSidebar;
